// extracted by mini-css-extract-plugin
module.exports = {"today":"Today-module--today--2x0Fd","body":"Today-module--body--3WnaV","title":"Today-module--title--2L2pg"};